import { NavLink } from "react-router-dom";
import {
  Home,
  Film,
  Tv,
  Newspaper,
  Flame,
  Menu
} from "lucide-react";
import { useState } from "react";
import "./Sidebar.css";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Top Section */}
      <div className="sidebar-top">
        <button className="menu-btn" onClick={() => setCollapsed(!collapsed)}>
          <Menu size={20} />
        </button>

        {/* {!collapsed && <span className="logo">watchit<span>Now</span></span>} */}
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <NavLink to="/" className="nav-item">
          <Home size={20} />
          {!collapsed && <span>Home</span>}
        </NavLink>

        <NavLink to="/movies" className="nav-item">
          <Film size={20} />
          {!collapsed && <span>Movies</span>}
        </NavLink>

        <NavLink to="/webseries" className="nav-item">
          <Tv size={20} />
          {!collapsed && <span>Web Series</span>}
        </NavLink>

        {/* <NavLink to="/news" className="nav-item">
          <Newspaper size={20} />
          {!collapsed && <span>News</span>}
        </NavLink> */}

        <NavLink to="/shorts" className="nav-item">
          <Flame size={20} />
          {!collapsed && <span>Shorts</span>}
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;
